import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app"

export default defineNuxtRouteMiddleware(to => {
  if (to.path === "/blog/demenz-falschen-beschuldigungen") {
    return navigateTo("/blog/demenz-falsche-beschuldigungen", {
      redirectCode: 301,
    })
  }
})
